import { render, staticRenderFns } from "./PosDispatchModal.vue?vue&type=template&id=2736c105"
import script from "./PosDispatchModal.vue?vue&type=script&lang=js"
export * from "./PosDispatchModal.vue?vue&type=script&lang=js"
import style0 from "./PosDispatchModal.vue?vue&type=style&index=0&id=2736c105&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports